import { useQuery } from "@tanstack/react-query";

import { UMSrequestClient } from "../stores/requestClient";
import type { TeamID } from "../types";

export const activeSubscriptionQueryKey = ["activeSubscriptionQueryKey"];

export const useTeamActiveSubscription = (teamId?: TeamID) => {
  const enabled = Boolean(teamId);
  return useQuery({
    queryKey: [...activeSubscriptionQueryKey, teamId],
    queryFn: async () => {
      try {
        await UMSrequestClient.publicRequest({
          method: "GET",
          url: `/teams/${teamId}/active-subscription`,
        });
        return true;
      } catch {
        return false;
      }
    },
    enabled,
  });
};
